<template>
  <qx-card-form title="基础信息">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <span slot="plateNumber">
        <span class="plateNumber-register-tips yes" v-if="registerMsg === '未注册'">未注册</span>
        <span class="plateNumber-register-tips no" v-if="registerMsg === '已注册'">已注册</span>
      </span>

      <!-- 载重容积 -->
      <section slot="goodsWeight" slot-scope="prop">
        <el-input
          class="appendInputBox"
          v-model="prop.form.goodsWeight"
          placeholder="载重"
          :disabled="goodsWeightDisabled"
        >
          <span slot="suffix">
            <span class="unit">吨</span>
            <el-input
              class="inputAppendInput"
              v-model="otherFormData.lightGoodsSquare"
              :clear="true"
              placeholder="容积"
            >
              <span class="unit" slot="suffix">立方</span>
            </el-input>
          </span>
        </el-input>
      </section>
      <!-- 载重容积 end -->

      <!-- 外调车司机信息 -->
      <span slot="driverInfoComponent">
        <DriverInfoComponent
          ref="driverInfoComponent"
          :masterDriver="driverUser"
          :copilotDriver="copilotDriver"
          @chooseDriver="(driverInfo) => this.chooseDriver(driverInfo)"
          @chooseCopilotDriver="(driverInfo) => copilotDriver = driverInfo"
        />
      </span>
      <!-- 外调车司机信息 end -->
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>

<script>
import {
  checkVehicleNumber,
  // getBigImg
} from '@qx/utils/index';
import {
  getVehicleIsRegister,
  // getVehicleLicense,
} from 'api/car';
// import {
//   getFileUrl,
// } from 'api';
import DriverInfoComponent from './driverInfoComponent';
import {mapState} from 'vuex';

export default {
  components: {
    DriverInfoComponent,
  },
  data () {
    return {
      goodsWeightDisabled: false,

      // 车辆类型options备份
      vehicleClassOptionsBackup: [],
      drivingLicenseInfo: {},
      // 车辆信息原始数据备份（用来对比数据是否修改）
      vehicleInfoBackup: {},
      registerMsg: '',
      // 已注册车辆信息
      vehicleInfo: null,
      // 主驾
      driverUser: {
        driverUserId: '',
        driverUserPhone: '',
        driverUserName: '',
      },
      // 副驾
      copilotDriver: {
        copilotDriverId: '',
        copilotDriverPhone: '',
        copilotDriverName: '',
      },
      otherFormData: {
        lightGoodsSquare: '', // 容积

        vehicleEarlyWarningDay: '',
        otherEarlyWarningDay: '',
        operateEarlyWarningDay: '',
        ['ext.gpsWaringDay']: '',
        relId: '',
        // 下面的字段都是不知道什么用，单身接口获取过来需要回传回去的
        ['ext.driveTypeName']: '',
        tenantVehicleCostRelId: '',
        isAuth: '',
        isOwnCar: '',
        tenantId: '',
        linkMan: '',
        authStateName: '',
        authState: '',
        otherOwnCar: '',
        tenantName: '',
        vehicleClassName: '',
        tenantVehicleCertRelId: '',
        adminUser: '',
        driverCarUserType: '',
        copilotDriverUserType: '',
      },
      baseForm: {
        // 归属部门
        orgIdOptions: [],
        // 牌照类型
        licenceTypeOptions: [],
        // 车辆类型
        vehicleStatusOptions: [],
        // 车辆种类
        vehicleClassOptions: [],
        // 能源类型
        energyTypeOptions: [],
        inline: true,
        form: [
          {
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            onChange: async (plateNumber) => {
              this.checkVehiclePlateNumberCanRegister(plateNumber);
            },
            onInput: async (plateNumber) => {
              this.checkVehiclePlateNumberCanRegister(plateNumber);
            },
          },
          {
            label: '车辆种类',
            value: 'vehicleClass',
            type: 'select',
            disabled: false,
            onChange: async () => {
              const formData = await this.$refs.baseForm.getVal();
              this.$emit('vehicleClassChange', formData.vehicleClass);
              const vehicleClass = this.$refs.baseForm.getVal('vehicleClass');
              if (vehicleClass !== '1') {
                this.setFormAttrVal({
                  form: this.baseForm,
                  attr: 'hide',
                  value: true,
                  names: ['remark'],
                });
              }
              const hideOrgId = vehicleClass === '3' && (this.userInfo.staffTFInfo.tenantId === 2483 || this.userInfo.staffTFInfo.tenantId === 2536 || this.userInfo.staffTFInfo.tenantId === 2538);
              this.setFormAttrVal({
                form: this.baseForm,
                attr: 'hide',
                value: hideOrgId,
                names: ['orgId'],
              });
              this.setOrgIdRequirement(!hideOrgId);

            },
          },
          {
            label: '归属部门',
            value: 'orgId',
            type: 'select',
            hide: false,
          },
          {
            label: '牌照类型',
            value: 'licenceType',
            type: 'select',
            disabled: false,
            onChange: () => {
              this.handleLicenceTypeChange();
            },
          },
          {
            label: '能源类型',
            value: 'energyType',
            type: 'select',
            hide: false,
            onChange: () => {
              this.handleEnergyTypeChange();
            },
          },
          {
            label: '备注',
            value: 'remark',
            type: 'input',
            hide: true,
          },
          {
            label: '车辆类型',
            value: 'vehicleStatus',
            type: 'cascader',
            normal: true,
            hide: true,
            default: [],
          },
          {
            label: '载重容积',
            value: 'goodsWeight',
            slot: true,
            hide: true,
            disabled: true,
          },
          {
            value: 'driverInfoComponent',
            slot: true,
            hide: false,
          },
        ],
        rules: {
          plateNumber: [ // 车牌号码
            { required: true, message: '请输入车牌号码', trigger: 'blur' },
          ],
          vehicleClass: [ // 车辆种类
            { required: true, message: '请选择车辆种类', trigger: 'blur' },
          ],
          orgId: [
            { required: true, message: '请选择归属部门', trigger: 'blur' },
          ],
          licenceType: [ // 牌照类型
            { required: true, message: '请选择牌照类型', trigger: 'blur' },
          ],
          vehicleStatus: [ // 车辆类型
            { required: true, message: '请选择车辆类型', trigger: 'blur' },
          ],
          goodsWeight: [ // 载重容积
            { required: true, message: '请输入载重', trigger: 'blur' },
            { validator: this.checkGoodsVolume, trigger: 'blur' },
          ],
          energyType: [ // 能源类型
            { required: true, message: '请选择能源类型', trigger: 'blur' },
          ],
        },
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    chooseDriver (data) {
      this.driverUser = data;
    },
    async setList (options) {
      this.vehicleClassOptionsBackup = JSON.parse(JSON.stringify(options.vehicleClassOptions));
      this.otherFormData.vehicleEarlyWarningDay = options.vehicleEarlyWarningDay;
      this.otherFormData.otherEarlyWarningDay = options.otherEarlyWarningDay;
      this.otherFormData.operateEarlyWarningDay = options.operateEarlyWarningDay;
      this.otherFormData['ext.gpsWaringDay'] = options.gpsWaringDay;
      this.baseForm.orgIdOptions = options.orgIdOptions;
      this.baseForm.licenceTypeOptions = options.licenceTypeOptions;
      this.baseForm.vehicleStatusOptions = options.vehicleStatusOptions;
      this.baseForm.energyTypeOptions = options.energyTypeOptions;
    },
    setOrgIdRequirement (required) {
      if (this.baseForm.rules.orgId && this.baseForm.rules.orgId[0]) {
        this.baseForm.rules.orgId[0].required = required;
      }
    },
    // 检测车牌号码格式以及是否已在此车队注册
    async checkVehiclePlateNumberCanRegister (plateNumber) {
      plateNumber = plateNumber.replace(/(^\s+)|(\s+$)/g, '') || this.$refs.baseForm.getVal('plateNumber');
      if (checkVehicleNumber(plateNumber)) {
        const res = await getVehicleIsRegister({ plateNumber });
        if (!res.failed) {
          if (res && res !== 'N') {
            // 已注册
            if (res.state === -1) {
              // 可邀请，改为邀请模式
              this.registerMsg = '已注册';
              this.vehicleInfo = res;
            } else {
              // 不可邀请，恢复原形
              this.registerMsg = '';
              this.vehicleInfo = null;
              this.$message({
                type: 'error',
                message: '该车辆已经被邀请!',
              });
            }
            this.$emit('switchToInvite', this.vehicleInfo);
          } else {
            // 未注册，恢复原形
            this.registerMsg = '未注册';
            this.vehicleInfo = null;
            this.$emit('switchToInvite', this.vehicleInfo);
          }
        }
        this.$refs.baseForm.setVal('plateNumber', plateNumber);
      } else {
        this.registerMsg = '';
        this.vehicleInfo = null;
      }
      // eslint-disable-next-line no-empty
      // 判断是测试，福朋，sc的时候 输入车牌号，隐藏归属部门
      const hideOrgId = this.userInfo.staffTFInfo.tenantId === 2483 || this.userInfo.staffTFInfo.tenantId === 2536 || this.userInfo.staffTFInfo.tenantId === 2538;
      if (hideOrgId) {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: true,
          names: ['orgId'],
        });
      }
      this.setOrgIdRequirement(!hideOrgId);
    },
    checkGoodsVolume (rule, value, call) {
      if (this.otherFormData.lightGoodsSquare) {
        call();
      } else {
        call('请输入容积');
      }
    },
    // 设置车辆参数（车架号和发动机号）
    async setVehicleParams (drivingLicenseInfo) {
      this.drivingLicenseInfo = drivingLicenseInfo;
      this.checkVehiclePlateNumberCanRegister(drivingLicenseInfo.plateNumber);
    },
    async handleEnergyTypeChange (inviteData) {
      const formData = await this.$refs.baseForm.getVal();
      this.$emit('energyTypeChange', formData.energyType);
    },
    // 当牌照类型是【整车】时，需要额外填写【车辆类型】和【载重容积】
    handleLicenceTypeChange (inviteData) {
      // 有返回邀请数据时，全部填上
      if (inviteData) {
        if (inviteData.licenceType) {
          this.$refs.baseForm.setVal('licenceType', `${inviteData.licenceType}`);
        }
        this.$refs.baseForm.setVal('vehicleStatus', [
          String(inviteData.vehicleStatus || ''),
          String(inviteData.vehicleLength || ''),
        ]);
        this.$refs.baseForm.setVal('goodsWeight', inviteData.vehicleLoad);
        this.otherFormData.lightGoodsSquare = inviteData.lightGoodsSquare;
      }

      const licenceType = this.$refs.baseForm.getVal('licenceType');
      // 显示额外字段
      let showExtraField = false;
      if (`${licenceType}` === '1') {
        // 整车，增加必填【车型/车长】【载量/容积】
        showExtraField = true;
      } else {
        // 牵引车，去掉必填【车型/车长】【载量/容积】
        showExtraField = false;
      }
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: !showExtraField,
        names: ['vehicleStatus', 'goodsWeight'],
      });
      this.baseForm.rules.vehicleStatus[0].required = showExtraField;
      this.baseForm.rules.goodsWeight[0].required = showExtraField;
    },
    // 这个函数抄原来的
    /* eslint-disable */
    setCurrentFlag () {
      const vehicleClass = `${this.$route.query.vehicleClass}`; // 原车辆类型
      const currentVehicleClass = `${this.$refs.baseForm.getVal('vehicleClass')}`; // 当前的车辆种类
      let flag = 0;
      //  自有车,招商车,挂靠车修改
      if (vehicleClass === currentVehicleClass && (currentVehicleClass === 1 || currentVehicleClass === 2 || currentVehicleClass === 4)) {
        flag = 1;
      }
      // 自有车=>招商车、挂靠车
      if (vehicleClass === 1 && (currentVehicleClass === 2 || currentVehicleClass === 4)) {
        flag = 2;
      }
      // 招商车,挂靠车(互转)===>自有车(邀请)
      if ((vehicleClass !== currentVehicleClass && vehicleClass !== 3 && vehicleClass !== 1) && (currentVehicleClass !== 3)) {
        flag = 5;
      }
      // 自有车,招商车,挂靠车=>外调车
      if ((vehicleClass === 1 || vehicleClass === 2 || vehicleClass === 4) && currentVehicleClass === 3) {
        flag = 3;
      }
      // 修改外调车
      if ((vehicleClass === currentVehicleClass && currentVehicleClass === 3)) {
        flag = 3;
      }
      // 外调车===>自有车、招商车、挂靠车(邀请)
      if (vehicleClass === 3 && (currentVehicleClass === 1 || currentVehicleClass === 2 || currentVehicleClass === 4)) {
        flag = 4;
      }
      return flag;
    },
    // 修改车辆种类为【临时外调车时】
    changeToOutward () {
      // 切换成临时外调车
      this.setBaseForm('outward');
      this.handleLicenceTypeChange();
    },
    resetToNormal () {
      // 恢复成正常模式
      this.setBaseForm('my');
      this.handleLicenceTypeChange();
    },
    /* eslint-enable */
    setBaseForm (mode) {
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'label',
        value: '车辆种类',
        names: ['vehicleClass'],
      });
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: false,
        names: ['licenceType'],
      });
      this.goodsWeightDisabled = false;
      if (mode === 'my') {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: true,
          names: ['vehicleStatus', 'goodsWeight', 'driverInfoComponent'],
        });
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: false,
          names: ['remark'],
        });
        this.baseForm.rules.vehicleStatus[0].required = true;
        this.baseForm.rules.goodsWeight[0].required = true;
      } else {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: false,
          names: ['licenceType', 'driverInfoComponent'],
        });
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: true,
          names: ['vehicleStatus', 'goodsWeight', 'energyType'],
        });
        // 车型/车长
        this.baseForm.rules.vehicleStatus[0].required = false;
        // 载重
        this.baseForm.rules.goodsWeight[0].required = false;
      }
    },
    // 设置所有表单
    resetBaseForm () {
      const vehicleClassOptionsBackup = JSON.parse(JSON.stringify(this.vehicleClassOptionsBackup));
      if (this.$route.query.type === 'my') {
        this.setBaseForm('my');
        // 从【我的车辆】进来，如果是【新增】，车辆种类需要隐藏【临时外调车】；如果是【修改】，需要全部展示
        // if (this.$route.query.id) {
        //   this.baseForm.vehicleClassOptions = vehicleClassOptionsBackup;
        // } else {
        //   const vehicleClassOptions = vehicleClassOptionsBackup.filter((item) => item.value !== '3');
        //   this.baseForm.vehicleClassOptions = vehicleClassOptions;
        // }

        // 因自有车档案列表查询接口返回的数据，后端已修改为只返回除外调车之外的车辆种类数据，所以无论自有车的新增修改，车辆种类都需要隐藏【临时外调车】
        const vehicleClassOptions = vehicleClassOptionsBackup.filter((item) => item.value !== '3');
        this.baseForm.vehicleClassOptions = vehicleClassOptions;
        // 隐藏除了【基础信息】和【车辆参数】之外的其他模块
      } else {
        this.setBaseForm('outward');
        if (this.$route.query.id) {
          this.baseForm.vehicleClassOptions = vehicleClassOptionsBackup;
        } else {
          // 从【外调车辆】新增进来，只能选择【临时外调车】，而且【车辆种类】选项禁用
          const vehicleClassOptions = vehicleClassOptionsBackup.filter((item) => item.value === '3');
          this.baseForm.vehicleClassOptions = vehicleClassOptions;
        }
      }
    },
    // 统一处理数据格式
    async handleSubData (cache) {
      let formData = null;
      let driverInfoData = null;
      let _this = null;
      if (this.$refs.driverInfoComponent) {
        _this = await this.$refs.driverInfoComponent;
      }
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
        if (_this) {
          driverInfoData = await _this.$refs.baseForm.getVal();
        }
      } else {
        formData = await this.$refs.baseForm.sub();
        if (_this) {
          driverInfoData = await _this.$refs.baseForm.sub();
        }
      }
      if (formData || cache) {

        if (this.vehicleInfo) {
          formData.vehicleCode = this.vehicleInfo.vehicleCode;
        } else {
          delete formData.vehicleCode;
        }

        const tempVehicleStatus = JSON.parse(JSON.stringify(formData.vehicleStatus));
        if (tempVehicleStatus.length) {
          formData.vehicleStatus = tempVehicleStatus[0];
          formData.vehicleLength = tempVehicleStatus[1];
        }
        formData.vehicleLoad = formData.goodsWeight;

        const vehicleClass = this.$refs.baseForm.getVal('vehicleClass');
        if (vehicleClass !== '1') {
          formData.remark = '';
        }
        formData = {
          ...formData,
          // 备份数据
          vehicleInfoBackup: this.vehicleInfoBackup,
          registerMsg: this.registerMsg,
          vehicleInfo: this.vehicleInfo,
          drivingLicenseInfo: this.drivingLicenseInfo,
          ...this.otherFormData,
          ...driverInfoData,
          driverUserId: driverInfoData ? driverInfoData.driver.userId : '',
        };

      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async sub () {
      let formData = await this.handleSubData();
      // 新建的情况下,如果使用了OCR识别，要对比和输入的车牌号是否一致，如果不一致 autoAudit = 0，否则为 1
      if (formData) {
        if (!this.$route.query.id) {
          // 新增状态，要判断识别出来的车牌号码和填写的车牌号码是否一致
          if (this.drivingLicenseInfo && this.drivingLicenseInfo.plateNumber) {
            if (this.drivingLicenseInfo.plateNumber !== formData.plateNumber) {
              formData.autoAudit = '0';
            } else {
              formData.autoAudit = '1';
            }
          } else {
            // 如果不上传行驶证，默认填写 0
            formData.autoAudit = '0';
          }
          // 这个用来识别新增还是修改
          formData.submitType = 'add';
        } else {
          // 这个用来识别新增还是修改
          formData.submitType = 'edit';
        }
        // 新增状态，提交一个参数，识别新增的是【我的车辆】还是【外调车】
        formData.addType = this.$route.query.type;
        formData.flag = this.setCurrentFlag();
        // 用来提交某个更新接口所需参数
        formData.vehicleClassOld = this.$route.query.vehicleClass;
        formData.driverUserIdOld = formData.vehicleInfoBackup.driverUserId;
        delete formData.vehicleInfoBackup;
        delete formData.vehicleInfo;
        delete formData.drivingLicenseInfo;
        delete formData.goodsWeight;
        delete formData.driver;
        delete formData.copilotDriver;
      }
      return formData;
    },
    async init (data = {}) {

      this.drivingLicenseInfo = data.drivingLicenseInfo;

      if (data.vehicleCode) {
        this.vehicleInfoBackup = data;
      }

      this.registerMsg = '';
      this.vehicleInfo = null;

      // 重置表单
      this.resetBaseForm();

      if (data.vehicleClass !== 1) {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: true,
          names: ['remark'],
        });
      }
      if (this.$route.query.type === 'outward') {
        const hideOrgId = this.userInfo.staffTFInfo.tenantId === 2483 || this.userInfo.staffTFInfo.tenantId === 2536 || this.userInfo.staffTFInfo.tenantId === 2538;
        // 设置表单元素的值
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: hideOrgId,
          names: ['orgId'],
        });
        this.setOrgIdRequirement(!hideOrgId);
      }
      if (data.orgId === undefined || data.orgId === null) {
        // 新建状态，默认展示一个【归属部门】

        if (this.userInfo.staffTFInfo.tenantId === 2483) { // 2483测试车队陈的tenantId，默认展示“测试导入部门”
          data.orgId = this.baseForm.orgIdOptions.filter((item) => item.value === 11050).length ? this.baseForm.orgIdOptions.filter((item) => item.value === 11050)[0].value : this.baseForm.orgIdOptions[0].value;
        } else if (this.userInfo.staffTFInfo.tenantId === 2536) { // 2536福鹏的tenantId，默认展示“车辆与司机”
          data.orgId = this.baseForm.orgIdOptions.filter((item) => item.value === 11151).length ? this.baseForm.orgIdOptions.filter((item) => item.value === 11151)[0].value : this.baseForm.orgIdOptions[0].value;
        } else if (this.userInfo.staffTFInfo.tenantId === 2538) { // 2538单翠的tenantId，默认展示“测试部”
          data.orgId = this.baseForm.orgIdOptions.filter((item) => item.value === 11160).length ? this.baseForm.orgIdOptions.filter((item) => item.value === 11160)[0].value : this.baseForm.orgIdOptions[0].value;
        } else { // 其他车队，【归属部门】进来默认选中第一个
          data.orgId = this.baseForm.orgIdOptions[0].value;
        }
      }

      if (data.lightGoodsSquare === undefined || data.lightGoodsSquare === null) {
        data.lightGoodsSquare = '0';
      }

      if (data.plateNumber) {
        if (!this.$route.query.id) {
          // 新增状态去检测车牌号码
          this.checkVehiclePlateNumberCanRegister(data.plateNumber);
        }
      }

      // 修改状态禁止修改”车牌号码“和”能源类型“
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: !!this.$route.query.id,
        names: ['plateNumber', 'energyType'],
      });

      this.$refs.baseForm.reset();
      // 下拉选项回填（因为返回的值有可能是数字，要改成字符串才能正常回填）
      if (data.vehicleClass !== undefined) {
        // 修改状态
        data.vehicleClass = String(data.vehicleClass);
      } else {
        // 新建状态，进来默认选中第一个
        data.vehicleClass = this.baseForm.vehicleClassOptions[0].value;
        this.$emit('vehicleClassChange', this.baseForm.vehicleClassOptions[0].value);
      }

      if (!data.energyType) {
        data.energyType = this.baseForm.energyTypeOptions[1].value;
      } else {
        this.$emit('energyTypeChange', data.energyType);
      }

      this.driverUser = {
        driverUserId: data.driverUserId,
        driverUserPhone: data.driverMobilePhone,
        driverUserName: data.driverName,
        driverCarUserType: data.driverCarUserType || '',
      };
      this.copilotDriver = {
        copilotDriverId: data.copilotDriverId,
        copilotDriverPhone: data.copilotDriverMobilePhone,
        copilotDriverName: data.copilotDriverUserName,
        copilotDriverUserType: data.copilotDriverUserType || '-1',
      };

      this.$refs.baseForm.setVal(data);
      this.setFormValFromData(this.otherFormData, data);
      // 数据回填时，如果是整车，需要展开额外填写的项
      this.handleLicenceTypeChange(data);
    },
    formChange (vehicleInfo) {
      this.resetBaseForm();
      const flag = !!vehicleInfo;
      // flag = false 未注册，新增模式，flag = true 已注册，邀请模式，
      if (flag) {
        let names = [];
        for (let item of this.baseForm.form) {
          // 留下【车牌号码】和【车辆类型】
          if (item.value !== 'plateNumber' && item.value !== 'vehicleClass') {
            names.push(item.value);
          }
        }
        // 修改【车辆类型】的label为【邀请为】
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'label',
          value: flag ? '邀请为' : '车辆种类',
          names: ['vehicleClass'],
        });

        let parametersFormNames = [];
        if (`${vehicleInfo.licenceType}` === '2') {
          // 如果是牵引车，则需要把车辆类型和载重容积都隐藏掉
          parametersFormNames.unshift('vehicleStatus', 'goodsWeight');
        }
        // 禁用【牌照类型】
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'disabled',
          value: true,
          names: ['licenceType'],
        });
        // 禁用载重容积
        this.goodsWeightDisabled = true;
        if (this.$refs.baseForm.getVal('vehicleClass') !== '1') {
          this.setFormAttrVal({
            form: this.baseForm,
            attr: 'hide',
            value: true,
            names: ['remark'],
          });
        }
      } else {
        if (this.$route.query.type === 'my') {
          this.setFormAttrVal({
            form: this.baseForm,
            attr: 'hide',
            value: false,
          });
          this.setFormAttrVal({
            form: this.baseForm,
            attr: 'hide',
            value: true,
            names: ['driverInfoComponent'],
          });
          if (this.$refs.baseForm.getVal('vehicleClass') !== '1') {
            this.setFormAttrVal({
              form: this.baseForm,
              attr: 'hide',
              value: true,
              names: ['remark'],
            });
          }
        } else {
          this.setFormAttrVal({
            form: this.baseForm,
            attr: 'hide',
            value: false,
          });
          this.setFormAttrVal({
            form: this.baseForm,
            attr: 'hide',
            value: true,
            names: ['energyType'],
          });
        }
      }
      this.handleLicenceTypeChange(vehicleInfo);
    },
    receivedData (vehicleInfo) {
      this.formChange(vehicleInfo);
    },
  },
};
</script>

<style scoped lang="scss">
.plateNumber-register-tips {
  margin-left: 16px;
  &.yes {
    color: #13ce66;
  }
  &.no {
    color: red;
  }
}
</style>
